<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuth } from '@/auth/auth'

const route = useRoute()
const auth = useAuth()
const accountCreated = computed(() => route.query.registered === '1')

const login = () => {
  auth.login()
}
</script>

<template>
  <section class="login-page">
    <p v-if="accountCreated" class="status-message" role="status">
      Account created successfully. You can log in now.
    </p>

    <button class="login-action" type="button" @click="login">Log in</button>
  </section>
</template>

<style scoped>
.login-page {
  display: grid;
  align-content: start;
  justify-items: start;
  gap: 1rem;
  padding: 2rem 1.5rem;
}

.status-message {
  margin: 0;
  color: #aee0b6;
}

.login-action {
  border: 1px solid #4caf50;
  background: #4caf50;
  color: #08120a;
  border-radius: 8px;
  min-height: 2.35rem;
  padding: 0.6rem 0.95rem;
  cursor: pointer;
  font-weight: 700;
}

.login-action:hover {
  background: #58c45d;
}
</style>
